import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BYOTermBreakdown } from 'src/app/models/byoTermResponse';
import { FeaturedInitials, InitialSearchResults } from 'src/app/models/initialsSearchResults';
import { Registration } from 'src/app/models/registration';
import {
  SearchReqResponse,
  SearchService,
} from 'src/app/services/search-service';
import { Location } from '@angular/common';
import { PageStep } from 'src/app/components/page-steps/page-steps.component';
import {
  TrackingService,
  TRACKING_SEARCH_TYPE,
} from 'src/app/services/tracking-service';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { FaqBuilder, InfoDropdown } from 'src/app/components/faq/faq.component';
import { DropdownOption, DropdownConfig } from 'src/app/components/custom-dropdown/custom-dropdown.component';
import { SidebarFilterConfig, SidebarFilterGroup, SidebarFilter } from 'src/app/components/side-bar-filters/side-bar-filters.component';
import { StickyConfig, StickyLink, StickyLinkGroup } from 'src/app/components/sticky-tabs/sticky-tabs.component';
import { SearchFilters } from '../search-results-page/search-results-page.component';
import GlobalFaqs from "../../global-faqs";

@Component({
  selector: 'pla-initials-search-page',
  templateUrl: './initials-search-page.component.html',
  styleUrls: ['./initials-search-page.component.scss'],
})
export class InitialsSearchPageComponent implements OnInit {
  public initialFeatured = new FeatureType('Number 1 Plates', 'initial');
  public initials: string;
  public dnf_searching: boolean = false;
  public dlf_searching: boolean = false;
  public current_searching: boolean = false;
  public prefix_searching: boolean = false;
  public suffix_searching: boolean = false;

  public initialResults: InitialSearchResults;
  public dnf_resultsChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public dlf_resultsChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public c_resultsChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public p_resultsChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public s_resultsChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  public featuredInitials: FeaturedInitials;


  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup([
        new StickyLink('Dateless Letter First', 'dateless-letter-first-results', true),
        new StickyLink('Dateless Number First', 'dateless-number-first-results', false),
        new StickyLink('Current Style', 'current-results', false),
        new StickyLink('Prefix Style', 'prefix-results', false),
        new StickyLink('Suffix Style', 'suffix-results', false),
        // new StickyLink('Q&As', 'faq', false),
      ].filter(x => x != null)),
    ],
    new EventEmitter<void>()
  );

  public termSorting: DropdownOption;
  public mobileFilterToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public filterChange: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  public filterUpdate: EventEmitter<SidebarFilterConfig<any>> =
    new EventEmitter<SidebarFilterConfig<any>>();
  public sortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
    new DropdownOption('A-Z', 'A-Z'),
    new DropdownOption('Z-A', 'Z-A'),
    new DropdownOption('LOW-TO-HIGH', 'Price Low to High'),
    new DropdownOption('HIGH-TO-LOW', 'Price High to Low')
  ]);
  public searchFilters: SidebarFilterConfig<SearchFilters> = new SidebarFilterConfig<SearchFilters>(
    [
      new SidebarFilterGroup('Sort By', [
        new SidebarFilter('sort', 'Sort By', 'sortBy', {
          selectConfig: this.sortDropdownConfig
        })
      ], { visible: true, customClass: 'd-block d-lg-none' }),
    ], this.filterChange);

  public pageSteps: PageStep[] = [
    new PageStep().AddBody('<b>Search</b> up to 3 initials'),
    new PageStep().AddBody(
      '<b>View</b> your initials on Current, Prefix, Suffix and Dateless Registrations'
    ),
    new PageStep().AddBody(
      '<b>Compare</b> deals across the whole market to get the best possible price'
    ),
    new PageStep().AddBody(
      '<b>Buy</b> direct with us or be transferred to the dealer to checkout with cash or finance'
    ),
  ]

  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey("Initials");

  constructor(
    private searchService: SearchService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private trackingService: TrackingService
  ) {
    this.initials = this.activatedRoute.snapshot.paramMap.get('initials');

    this.filterChange.subscribe((_: SearchFilters) => {
      this.SortChange(this.sortDropdownConfig.options.find(o => o.value === _.sortBy), "");
    });

    if (this.initials == null) return;
    this.trackingService.TrackSearch(
      TRACKING_SEARCH_TYPE.INITALS,
      this.initials
    );
  }

  ngOnInit(): void {
    // if (this.initials == null) this.initials = 'AAA'; // default
    if (this.initials == null) {
      this.getFeatured();
      return;
    }
    this.getSearchResults();
  }

  public SortChange(e: DropdownOption, key: string): void {
    if (this.initialResults === undefined ||
      this.initialResults.dateless_number_first === undefined ||
      this.initialResults.dateless_letter_first === undefined ||
      this.initialResults.current === undefined ||
      this.initialResults.prefix === undefined ||
      this.initialResults.suffix === undefined
    ) {
      console.log('cant sort nothing')
      return;
    }

    if (e.value === 'A-Z') {
      this.initialResults.dateless_number_first = this.initialResults.dateless_number_first.sort((a, b) => a.registration.localeCompare(b.registration));
      this.initialResults.dateless_letter_first = this.initialResults.dateless_letter_first.sort((a, b) => a.registration.localeCompare(b.registration));
      this.initialResults.current = this.initialResults.current.sort((a, b) => a.registration.localeCompare(b.registration));
      this.initialResults.prefix = this.initialResults.prefix.sort((a, b) => a.registration.localeCompare(b.registration));
      this.initialResults.suffix = this.initialResults.suffix.sort((a, b) => a.registration.localeCompare(b.registration));
    } else if (e.value === 'Z-A') {
      this.initialResults.dateless_number_first = this.initialResults.dateless_number_first.sort((a, b) => b.registration.localeCompare(a.registration));
      this.initialResults.dateless_letter_first = this.initialResults.dateless_letter_first.sort((a, b) => b.registration.localeCompare(a.registration));
      this.initialResults.current = this.initialResults.current.sort((a, b) => b.registration.localeCompare(a.registration));
      this.initialResults.prefix = this.initialResults.prefix.sort((a, b) => b.registration.localeCompare(a.registration));
      this.initialResults.suffix = this.initialResults.suffix.sort((a, b) => b.registration.localeCompare(a.registration));
    } else if (e.value === 'HIGH-TO-LOW') {
      this.initialResults.dateless_number_first = this.initialResults.dateless_number_first.sort((a, b) => b.price - a.price);
      this.initialResults.dateless_letter_first = this.initialResults.dateless_letter_first.sort((a, b) => b.price - a.price);
      this.initialResults.current = this.initialResults.current.sort((a, b) => b.price - a.price);
      this.initialResults.prefix = this.initialResults.prefix.sort((a, b) => b.price - a.price);
      this.initialResults.suffix = this.initialResults.suffix.sort((a, b) => b.price - a.price);
    } else if (e.value === 'LOW-TO-HIGH') {
      this.initialResults.dateless_number_first = this.initialResults.dateless_number_first.sort((a, b) => a.price - b.price);
      this.initialResults.dateless_letter_first = this.initialResults.dateless_letter_first.sort((a, b) => a.price - b.price);
      this.initialResults.current = this.initialResults.current.sort((a, b) => a.price - b.price);
      this.initialResults.prefix = this.initialResults.prefix.sort((a, b) => a.price - b.price);
      this.initialResults.suffix = this.initialResults.suffix.sort((a, b) => a.price - b.price);
    }

    this.dnf_resultsChange.emit(new SearchReqResponse('dnf_id', this.initialResults.dateless_number_first));
    this.dlf_resultsChange.emit(new SearchReqResponse('dlf_id', this.initialResults.dateless_letter_first));
    this.c_resultsChange.emit(new SearchReqResponse('c_id', this.initialResults.current));
    this.p_resultsChange.emit(new SearchReqResponse('p_id', this.initialResults.prefix));
    this.s_resultsChange.emit(new SearchReqResponse('s_id', this.initialResults.suffix));
  }

  public getFeatured(): void {
    this.searchService.featuredInitials((res) => {
      this.featuredInitials = res;
    });
  }

  public UpdateInitialsInput($event: string): void {
    this.initials = $event.toUpperCase();
    if (this.initials == null || this.initials == '') return;
    this.location.go(`/initials-search/${this.initials}`);
  }

  public doInlineSearch(): void {
    this.getSearchResults();
  }

  private getSearchResults(): void {
    this.dnf_searching = true;
    this.dlf_searching = true;
    this.current_searching = true;
    this.prefix_searching = true;
    this.suffix_searching = true;
    this.initialResults = new InitialSearchResults();

    this.searchService.searchInitials(
      this.initials,
      'current',
      (res: InitialSearchResults) => {
        this.current_searching = false;
        res.current.map((r: Registration) => (r.available = r.price >= 0));
        this.initialResults.current = res.current;
        this.c_resultsChange.emit(new SearchReqResponse('c_id', res.current));

        this.filterUpdate.emit(this.searchFilters);
      }
    );
    this.searchService.searchInitials(
      this.initials,
      'prefix',
      (res: InitialSearchResults) => {
        this.prefix_searching = false;
        res.prefix.map((r: Registration) => (r.available = r.price >= 0));
        this.initialResults.prefix = res.prefix;
        this.p_resultsChange.emit(new SearchReqResponse('p_id', res.prefix));
      }
    );
    this.searchService.searchInitials(
      this.initials,
      'dateless_number_first',
      (res: InitialSearchResults) => {
        this.dnf_searching = false;
        res.dateless_number_first.map(
          (r: Registration) => (r.available = r.price >= 0)
        );
        this.initialResults.dateless_number_first = res.dateless_number_first;
        this.dnf_resultsChange.emit(
          new SearchReqResponse('dnf_id', res.dateless_number_first)
        );
      }
    );
    this.searchService.searchInitials(
      this.initials,
      'dateless_letter_first',
      (res: InitialSearchResults) => {
        this.dlf_searching = false;
        res.dateless_letter_first.map(
          (r: Registration) => (r.available = r.price >= 0)
        );
        this.initialResults.dateless_letter_first = res.dateless_letter_first;
        this.dlf_resultsChange.emit(
          new SearchReqResponse('dlf_id', res.dateless_letter_first)
        );
      }
    );
    this.searchService.searchInitials(
      this.initials,
      'suffix',
      (res: InitialSearchResults) => {
        this.suffix_searching = false;
        res.suffix.map((r: Registration) => (r.available = r.price >= 0));
        this.initialResults.suffix = res.suffix;
        this.s_resultsChange.emit(new SearchReqResponse('s_id', res.suffix));
      }
    );
  }
}
